/*
  Mobile submenu behaviour only.

  Desktop opens panels on hover through CSS alone, and the panel markup is already in the page, so
  there is nothing to build or inject here. This exists because a tap has no hover equivalent.

  On mobile the whole row opens the submenu - there is no separate arrow. The row is still a real
  link to the collection, so without JavaScript a tap navigates there rather than doing nothing;
  the panel's heading links to the same collection once open.
*/
if (!window.mmNavigationLoaded) {
  window.mmNavigationLoaded = true;

  const setOpen = (item, open) => {
    item.classList.toggle('is-open', open);
    const link = item.querySelector(':scope > .mm-nav__link');
    if (link) link.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  document.body.addEventListener('click', event => {
    // Back out of an open panel. The whole head row is the control, not just the arrow, so this
    // matches the row itself - a click on the arrow, icon or title all resolve to it.
    // Checked first: the head sits inside the panel, which is inside the item, so the link check
    // below would otherwise swallow it.
    const back = event.target.closest('.mm-nav__panel-head');
    if (back) {
      const openItem = back.closest('.mm-nav__item');
      if (openItem) setOpen(openItem, false);
      return;
    }

    // Only the drawer opens on tap; desktop is hover-only and its links must navigate.
    const link = event.target.closest('.mm-nav--drawer .mm-nav__link');
    if (!link) return;

    const item = link.closest('.mm-nav__item');
    if (!item || !item.classList.contains('mm-nav__item--has-panel')) return;

    // Ignore clicks that came from inside the panel itself - those are real links.
    if (event.target.closest('.mm-nav__panel')) return;

    event.preventDefault();

    // Accordion: only one open at a time.
    item.closest('.mm-nav__list')
      .querySelectorAll('.mm-nav__item.is-open')
      .forEach(other => { if (other !== item) setOpen(other, false); });

    setOpen(item, !item.classList.contains('is-open'));
  });
}
